import { pyrotchBaseUrl, axiosBaseQuery } from "../axios/AxiosInstance";
import { createApi } from "@reduxjs/toolkit/query/react";
import { TaskRequest } from "../../models/Task";
import { TasksResponse } from "../../models/Task";
import { ApprovalRequestInput } from "../../models/Task";
import { format } from "date-fns";
import { updateTasks } from "../../redux/slice/board.slice";

export const TaskApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: pyrotchBaseUrl + "v1/",
  }),
  reducerPath: "taskApi",
  tagTypes: ["Task"],

  endpoints(build) {
    return {
      // createTask: build.mutation({
      //   query: (TaskData) => ({
      //     url: `tasks`,
      //     method: "POST",
      //     data: TaskData,
      //   }),
      //   invalidatesTags: ["Task"],
      // }),


      createTask: build.mutation<
        any,
        {
          data: any;
          files: File[];
        }
      >({
        query: ({ data, files }) => {
          const formData = new FormData();


          files.forEach((file) => {
            formData.append("files", file);
          });

          return {
            url: `tasks`,
            method: "POST",
            data: formData,
            params: data,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };
        },
        invalidatesTags: ["Task"],
      }),

      updateTask: build.mutation<
        any,
        {
          data: TaskRequest;
          files: File[];
        }
      >({
        query: ({ data, files }) => {
          const formData = new FormData();


          files.forEach((file) => {
            formData.append("files", file);
          });

          return {
            url: `tasks`,
            method: "PUT",
            data: formData,
            params: data,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };
        },
        invalidatesTags: ["Task"],
      }),

      deleteDocument: build.mutation<any, number>({
        query: (taskDocumentId) => {
          return {
            url: `tasks/document/${taskDocumentId}`,
            method: "DELETE",
          };
        },
        invalidatesTags: ["Task"],
      }),

      deleteRequest: build.mutation<any, { taskId: number; isApproved: boolean }>({
        query: ({ taskId, isApproved }) => ({
          url: `tasks/request-approval/${taskId}`,
          method: "DELETE" ,
          params: {
            isApproved: isApproved,
          },
        }),
        invalidatesTags: ["Task"],
      }),
      // updateTask: build.mutation<any, TaskRequest>({
      //   query: (TaskData) => ({
      //     url: `tasks`,
      //     method: "PUT",
      //     data: TaskData,
      //   }),
      //   invalidatesTags: ["Task"],
      // }),

      getTasks: build.query<TasksResponse, {
        page: number;
        size: number;
        search?: string;
        startDate?: string;
        endDate?: string;
        status?: string;
        filterUser?: number;
        teamTasks?: boolean
      }>({
        query: ({ page, size, search, startDate, endDate, status, filterUser, teamTasks }) => {
          // Format dates if they exist
          const formattedStartDate = startDate ? format(new Date(startDate), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx") : "";
          const formattedEndDate = endDate ? format(new Date(endDate), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx") : "";

          // Create an object with only parameters that have values
          const params: Record<string, string | number | boolean> = { page, size };
          if (search) params.search = search;
          if (startDate) params.startDate = formattedStartDate;
          if (endDate) params.endDate = formattedEndDate;
          if (status) params.status = status;
          if (filterUser !== undefined) params.filterUser = filterUser;
          if (teamTasks !== undefined) params.teamTasks = teamTasks;

          // Convert the params object into a query string
          const queryString = new URLSearchParams(params as Record<string, string>).toString();

          return {
            url: `tasks?${queryString}`,
            method: "GET",
          };
        },
        providesTags: ["Task"],
      }),
      deleteTasks: build.mutation<void, number>({
        query: (TaskId) => {
          return {
            url: `tasks?taskId=${TaskId}`,
            method: "DELETE",
          };
        },
        invalidatesTags: ["Task"],
      }),
      requestApprovalTask: build.mutation<any, number>({
        query: (taskId) => {
          return {
            url: `tasks/${taskId}/request-approval`,
            method: "Post",
          };
        },
        invalidatesTags: ["Task"],
      }),
      completedTask: build.mutation<any, number>({
        query: (taskId) => {
          return {
            url: `tasks/${taskId}/completed`,
            method: "Post",
          };
        },
        invalidatesTags: ["Task"],
      }),
      approveDeclineTask: build.mutation<any, ApprovalRequestInput>({
        query: ({ taskId, isApproved, declineComment }) => {
          const params = new URLSearchParams({
            isApproved: isApproved.toString(),
          });
          if (!isApproved && declineComment) {
            params.append("declineComment", declineComment);
          }
          return {
            url: `tasks/${taskId}/approve-Decline?${params.toString()}`,
            method: "Post",
          };
        },
        invalidatesTags: ["Task"],
      }),
      getTaskCount: build.query<{ approved: number; completed: number}, boolean>({
        query: (teamTasks) => ({
          url: `tasks/count?teamTasks=${teamTasks}`,
          method: "GET",
        }),
        providesTags: ["Task"],
      })
    };
  },
});

export const {
  useCreateTaskMutation,
  useLazyGetTasksQuery,
  useDeleteTasksMutation,
  useUpdateTaskMutation,
  useDeleteDocumentMutation,
  useDeleteRequestMutation,
  useRequestApprovalTaskMutation,
  useCompletedTaskMutation,
  useApproveDeclineTaskMutation,
  useLazyGetTaskCountQuery
} = TaskApi;
